import { createContext } from 'react';

import { ViewContextType } from './ViewContext.types';

export const ViewContext = createContext<ViewContextType>({
  defaultCardsNum: 0,
  showedCardsNum: 0,
});
